var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var DynamicValidateService = /** @class */ (function () {
    function DynamicValidateService() {
    }
    DynamicValidateService.prototype.boundVali = function (dynamicSetting, validate) {
        var validations = [];
        var result;
        if (dynamicSetting.isTranslation) {
            if (dynamicSetting.isHorizontalTranslation) {
                result = this.allowedValue(dynamicSetting.horizontalTranslation.minCoordinate, dynamicSetting.horizontalTranslation.maxCoordinate, validate.minXCoordinate, validate.maxXCoordinate);
                validations.push(result);
                if (dynamicSetting.horizontalTranslation.isProportion) {
                    result = this.allowedValue(dynamicSetting.horizontalTranslation.minProportionScale, dynamicSetting.horizontalTranslation.maxProportionScale, validate.minXProportionScale, validate.maxXProportionScale);
                    validations.push(result);
                }
                else {
                    result = true;
                    validations.push(result);
                }
            }
            if (dynamicSetting.isVerticalTranslation) {
                result = this.allowedValue(dynamicSetting.verticalTranslation.minCoordinate, dynamicSetting.verticalTranslation.maxCoordinate, validate.minYCoordinate, validate.maxYCoordinate);
                validations.push(result);
                if (dynamicSetting.verticalTranslation.isProportion) {
                    result = this.allowedValue(dynamicSetting.verticalTranslation.minProportionScale, dynamicSetting.verticalTranslation.maxProportionScale, validate.minYProportionScale, validate.maxYProportionScale);
                    validations.push(result);
                }
                else {
                    result = true;
                    validations.push(result);
                }
            }
        }
        if (dynamicSetting.isRotation) {
            result = this.allowedValue(dynamicSetting.rotation.minAngle, dynamicSetting.rotation.maxAngle, validate.minAngle, validate.maxAngle);
            validations.push(result);
            if (dynamicSetting.verticalTranslation.isProportion) {
                result = this.allowedValue(dynamicSetting.rotation.minProportionScale, dynamicSetting.rotation.maxProportionScale, validate.minRotateProportionScale, validate.maxRotateProportionScale);
                validations.push(result);
            }
            else {
                result = true;
                validations.push(result);
            }
        }
        return (validations.indexOf(false) >= 0) ? false : true;
    };
    DynamicValidateService.prototype.allowedValue = function (topLimit, lowerLimit, min, max) {
        var isallowedValue;
        if (topLimit == null || topLimit === undefined || lowerLimit == null || lowerLimit === undefined) {
            isallowedValue = false;
        }
        else {
            isallowedValue = ((topLimit < lowerLimit) && (min <= topLimit) && (topLimit <= max) && (min <= lowerLimit) && (lowerLimit <= max)) ? true : false;
        }
        return isallowedValue;
    };
    DynamicValidateService = __decorate([
        Injectable()
    ], DynamicValidateService);
    return DynamicValidateService;
}());
export { DynamicValidateService };
